/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
} from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import ModalConfirmation from 'components/ModalConfirmation';
import { getEstadosGlobales } from 'api/catalogos/index';
import {
  getPorcentajesDeSueldos,
  getPorcentajeDeSueldo,
  postPorcentajeDeSueldo,
  patchPorcentajeDeSueldo,
  deletePorcentajeDeSueldo,
} from 'api/catalogos/porcentajePagoSueldo';
import { checkToken } from 'api/utils';
import {
  SLUG_PATTERN,
} from 'utils/patterns';
import {
  ESTATUS_ACTIVO,
  ESTATUS_CANCELADO,
  ESTATUS_AUTORIZADO,
  ESTATUS_INACTIVO,
} from '../../../utils/constants';

export const porcentajePagoSueldoPermission = {
  permissionModel: 'incidenciaporcentajedesueldo',
  catalogsModels: [],
  tabsModels: [],
};

const PorcentajePagoSueldo = ({ permission }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState();
  const [open, setVisible] = useState();
  const [visibleAlert, setVisibleAlert] = useState();
  const [estados, setEstados] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [confirmationVisibleEstatus, setConfirmationVisibleEstatus] = useState(false);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [form] = Form.useForm();
  const [disableAuth, setDisableAuth] = useState(false);

  const formInstances = [
    form,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getPorcentajesDeSueldos();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getPorcentajesDeSueldos(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setEstatusInactivo(false);
    setEstatusAutorizado(false);
    setSelectedRowKeys([]);
    setVisible(false);
    form.resetFields();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _porcentajePagoSueldo = await getPorcentajeDeSueldo(match.id);
    if (_porcentajePagoSueldo?.estados_globales === ESTATUS_ACTIVO
      || _porcentajePagoSueldo?.estados_globales === ESTATUS_INACTIVO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_INACTIVO
      || estado?.id === ESTATUS_ACTIVO));
    }
    if (_porcentajePagoSueldo?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_AUTORIZADO));
      setEstatusAutorizado(true);
    }
    if (_porcentajePagoSueldo?.estados_globales === ESTATUS_INACTIVO) {
      setEstatusInactivo(true);
    }
    setTimeout(() => {
      if (_porcentajePagoSueldo) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(_porcentajePagoSueldo));
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      const saved = await (key
        ? patchPorcentajeDeSueldo(key, values)
        : postPorcentajeDeSueldo(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deletePorcentajeDeSueldo(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    const isAutorizado = record?.estados_globales === ESTATUS_AUTORIZADO;
    const isInactivo = record?.estados_globales === ESTATUS_INACTIVO;
    setDisableAuth(isAutorizado || isInactivo);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    setEstadosFiltered(estados);
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una nómina ya autorizada');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        estados_globales: ESTATUS_AUTORIZADO,
      };
      const res = await patchPorcentajeDeSueldo(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationEstatus = async () => {
    setConfirmationVisibleEstatus(false);
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 100,
    },
    {
      titleText: 'Concepto',
      dataIndex: 'concepto',
      key: 'concepto',
      width: 250,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 100,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
      {
        validator: async (_, value) => {
          const { aplica_porcentaje_personalizado: porcentajePersonalizado } = form.getFieldValue();
          const numeroEnteroBooleano = (/^\d+$/.test(value));
          if (!porcentajePersonalizado && !numeroEnteroBooleano) {
            throw new Error('Debe aplicar porcentaje personalizado para que la clave pueda contener letras.');
          }
        },
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          disableDelete={
            data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
          }
          customActions={[
            {
              onClick: () => setConfirmationVisible(true),
              permission: { model: 'incidenciaporcentajedesueldo', action: 'autorizar' },
              text: 'Autorizar',
              icon: <CheckCircleOutlined />,
              disabledBySelection: false,
              className: 'success',
              disabled: !selectedRowKeys?.length
                || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
            },
          ]}
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          footer={null}
          width={600}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Porcentaje de Pago de Sueldo`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave={!selectedRowKeys?.length || !disableAuth}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
          >
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="clave"
                rules={rules.clave}
                label="Clave"
                hasFeedback
              >
                <Input
                  allowClear
                  disabled={estatusAutorizado || estatusInactivo}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="concepto"
                label="Concepto"
                rules={rules.required}
                hasFeedback
              >
                <Input
                  allowClear
                  disabled={estatusAutorizado || estatusInactivo}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="aplica_porcentaje_personalizado"
                label="Aplica Porcentaje Personalizado"
                rules={rules.required}
                hasFeedback
                initialValue={false}
              >
                <Select
                  trueFalse
                  allowClear
                  disabled={estatusAutorizado || estatusInactivo}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="estados_globales"
                label="Estatus"
                rules={rules.estatus}
                hasFeedback
                initialValue={1}
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={estadosFiltered}
                  disabled={!selectedRowKeys.length || estatusAutorizado || estatusInactivo}
                  onChange={(val) => {
                    if (val === ESTATUS_INACTIVO) {
                      setConfirmationVisibleEstatus(true);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Porcentaje de Pago de Sueldo ${form.getFieldValue('concepto')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar el Porcentaje de Pago de Sueldo ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationEstatus}
          ConfirmInactive
          onCancel={() => {
            setConfirmationVisibleEstatus(false);
            form.setFieldValue('estados_globales', 1);
          }}
          open={confirmationVisibleEstatus}
          contentTitle={`Inactivar el Porcentaje de Pago de Sueldo ${form.getFieldValue('clave')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default PorcentajePagoSueldo;
